// Coaching: a coach's published profile as members read it, and the coach's own side of benefits.
//
// Same vocabulary as `benefits`: a member CLAIMS, and the coach ACCEPTS and later marks it USED.
// Nothing here says "redeem" — that is the server's word for the same act, and it reads to a coach
// like taking a payment.

const coach = {
  loading: 'Loading…',
  tryAgain: 'Try again',
  cancel: 'Cancel',

  // --- Public profile ---------------------------------------------------------------------------
  unnamed: 'This coach',
  viewPlayerProfile: 'See ratings and match history',
  offersTitle: 'What you can claim here',
  websiteTitle: 'Website',
  claimHere: 'Claim a benefit here',
  claimHereHint: "Claiming reserves it with this coach. You'll arrange the session with them directly.",
  aboutTitle: 'About',
  yearsCoaching: 'Years coaching',
  certifications: 'Certifications',

  notFoundTitle: "We couldn't find that coach",
  notFoundDesc: 'The profile may have been withdrawn, or the link may be out of date.',

  // --- The coach's own surface ------------------------------------------------------------------
  title: 'Coaching',
  subtitle: 'Answer claims and keep your profile current.',
  viewPublicProfile: 'View public profile',
  whichProfile: 'Profile',
  // `status` arrives lowercased from the server's own vocabulary, so the sentence reads for any
  // status the platform grows rather than only the two that exist today.
  notActive: "Your profile is {{status}}, so members can't find or claim with you right now.",

  notACoachTitle: "You don't have a coaching profile",
  notACoachDesc: 'Coaching profiles are set up by DUPR. Contact support if you think you should have one.',
  loadFailedTitle: "We couldn't load your coaching profile",
  loadFailedDesc: 'Something went wrong on our end — try again.',

  tabClaims: 'Claims',
  tabProfile: 'My profile',

  // --- Claims -----------------------------------------------------------------------------------
  waitingHeading: 'Waiting on you ({{count}})',
  acceptedHeading: 'Accepted',
  claimedOn: 'Claimed {{date}}',
  answerBy: 'Answer by {{date}}',
  accept: 'Accept',
  decline: 'Decline',
  confirmDecline: 'Decline claim',
  declineReasonLabel: 'Reason (optional)',
  declineReasonPlaceholder: "Let them know why — they'll be able to claim elsewhere",
  markUsed: 'Mark as used',
  markUsedHint: "For your own records. It doesn't change anything for the member.",
  usedOn: 'Used {{date}}',
  answerFailed: "That didn't go through. Please try again.",

  noClaimsTitle: 'Nobody has claimed with you yet',
  noClaimsDesc: 'Members who claim a benefit with you will show up here.',
  // Kept apart from the empty state above: telling a coach nobody has claimed, because a request
  // failed, is how a member waits a week for an answer that was never coming.
  claimsFailedTitle: "We couldn't load your claims",
  claimsFailedDesc: 'Something went wrong on our end — try again.',

  // --- Profile ----------------------------------------------------------------------------------
  headlineLabel: 'Headline',
  headlinePlaceholder: 'Third-shot drops and dinks',
  headlineHint: 'One line, shown next to your name when members are choosing.',
  bioLabel: 'About you',
  bioPlaceholder: 'What players should know before booking with you.',
  yearsLabel: 'Years coaching',
  certificationsLabel: 'Certifications',
  certificationsPlaceholder: 'PPR Level 1, IPTPA',
  noProfileSchema: "We couldn't load the fields for this kind of profile.",
  saveProfile: 'Save profile',
  saveProfileFailed: "We couldn't save your profile. Please try again.",
  profileSaved: 'Profile saved.',
}

export default coach
